import React from 'react';

const ErrorIndicator: React.FC = () => {
  return <div>Error</div>;
};
export default ErrorIndicator;
